import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  paper: {
    margin: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  hasPopupIcon: {},
  popupIndicator: {
    padding: 0,
  },
  popupIndicatorOpen: {
    transform: 'none',
  },
  endAdornment: {
    top: 'calc(50% - 16px)',
  },
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': {
      '$hasPopupIcon, &': {
        paddingRight: theme.spacing(13),
        minHeight: 60,
      },
      '& $endAdornment': {
        right: 20,
      },
    },
  },
  clearIndicator: {
    marginRight: theme.spacing(),
    backgroundColor: theme.palette.grey[300],
    '&:hover': {
      backgroundColor: theme.palette.grey[300],
    },
  },
  option: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular,
    '&[aria-selected="true"]': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
    },
    '&[data-focus="true"]': {
      color: theme.palette.text.primary,
    },
    '&:active': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
    },
  },
}));
